import { BrowserRouter, Route, Switch } from "react-router-dom";

import React from "react";
import AboutUsView from "./views/AboutUsView";
import RecenzeView from "./views/RecenzeView";
import {
  schoolTypeHighSchool,
  schoolTypeUniversity,
} from "./constants/constants";
import CreditSystemPage from "./components/CreditSystem/CreditSystemPage";
import { useCookies } from "react-cookie";
import FaqPage from "./components/FaqPage/FaqPage";
import { LANDING_PAGES } from "./constants/landingPages";
import LandingPageView from "./views/LandingPageView";
import CollectionOfExamplesListView from "./views/CollectionOfExamplesListView";
import HomepageView from "./views/HomepageView";
import CourseView from "./views/CourseView";
import NotFoundView from "./views/NotFoundView";

const Routes = (props) => {
  const [cookies, setCookie, removeCookie] = useCookies();

  React.useEffect(() => {
    if (window.location.search !== "") {
      const urlParams = new URLSearchParams(window.location.search);
      const s = urlParams.get("s");
      setCookie("shareLink", s, { path: "/" });
    }
  }, [window.location.search]);

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => <HomepageView {...props} schoolType={null} />}
        />
        <Route
          exact
          path="/sbirky-prikladu"
          component={CollectionOfExamplesListView}
        />
        <Route exact path="/o-fifovi" component={AboutUsView} />
        <Route exact path="/recenze" component={RecenzeView} />
        <Route exact path="/faq" component={FaqPage} />
        <Route exact path="/doporuc-a-ziskej" component={CreditSystemPage} />
        {LANDING_PAGES.map((lp) => {
          return (
            <Route
              exact
              path={"/" + lp.url}
              render={(props) => <LandingPageView {...props} url={lp.url} />}
            />
          );
        })}
        <Route
          exact
          path={"/" + schoolTypeUniversity}
          render={(props) => (
            <HomepageView {...props} schoolType={schoolTypeUniversity} />
          )}
        />
        <Route
          exact
          path={"/" + schoolTypeHighSchool}
          render={(props) => (
            <HomepageView {...props} schoolType={schoolTypeHighSchool} />
          )}
        />
        <Route path="/kategorie/:slug" component={HomepageView} />
        <Route path="/kurz/:slug" component={CourseView} />
        <Route path="/sbirky-prikladu/:slug" component={CourseView} />
        <Route path="*" component={NotFoundView} />

        {/*<Route path="*" component={Error404} />*/}
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
